import { createPathParamCRUD, type NoPathParams } from "@/api/shared/crud";
import type { DefaultPaginatedFilters } from "@/api/shared/filters";
import type { EMsoType, TMso, TMsoWrite } from "./types";
import { createService } from "@/api/shared/service";

export * from "./types";

export const msoTypeSelectable = (item: EMsoType) => {
  return {
    title: item.toUpperCase(),
    value: item,
  };
};
export const msoSelectable = (item: TMso) => {
  return {
    title: item.name,
    value: item.id,
  };
};
const SLUG = "practice/mso";
const SEARCH_SLUG = `${SLUG}/search`;

export default createService(SLUG, {
  ...createPathParamCRUD<TMso, NoPathParams, DefaultPaginatedFilters, TMsoWrite, TMsoWrite>(
    SLUG,
    SEARCH_SLUG
  ),
});
